import authSdk from '../sdk'

const livechat = authSdk.createAxiosInstance({
    baseURL: import.meta.env.APP_LIVECHAT_API_URL,
})

export default livechat
